import * as ACTION from "../../Redux.constants";
import { setLevel } from "./SetLevel";

export function LevelReducer(state, action) {
  switch (action.type) {
    case ACTION.SET_LEVEL:
      return setLevel(state, action.payload);
    default:
      return state;
  }
}
